import "./navbartest.css"
import React from 'react'
import AITestContext from '../../../contexts/AITestContext'

import {Nav} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ArrowBack } from "@mui/icons-material"
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import { DisplayMyCreatedTests } from '../aitest/DisplayMyCreatedTests'
import CircularProgress from '@mui/material/CircularProgress';
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import { useState} from "react"
import Checkbox from '@mui/material/Checkbox';


export const NavBarTest = ({ title })=> {

  const[openSaveTestDialog, setSaveTestDialogBox] = useState(false)

 
  let {
    chatName,
    chatNames,
    setChatName,
    onSave,
    handleDeleteTest,
    deleteTest, 
    displayChat,
    promptsandresponses,
    createtestmode,
    selecttestmode,
    handleonArrowClick,
    setExpanded,
    expanded,
    openDialog, 
    setOpenDialogBox,
    dialogboxtext,
    openConfirmDialog, 
    setOpenConfirmDialogBox,
    isLoading,
    handleonClickNavBar,

    createcollegetestmode,
   
} = React.useContext(AITestContext);


let {
  statusNavbar,
  changeLanguage,
} = React.useContext(StatusContext);


const alertYes = () => {
  closeDialogBox()
  deleteTest()
}

const alertCancel = () => {
  closeDialogBox()
}

const closeDialogBox = () => {
  setOpenDialogBox(false);
};

const alertSaveTestYes = () => {
  closeSaveTestDialogBox()
  //deleteTest()
}

const alertSaveTestCancel = () => {
  closeSaveTestDialogBox()
}

const closeSaveTestDialogBox = () => {
  setSaveTestDialogBox(false);
};

const confirmYes = () => {
  closeConfirmDialogBox()
 
}

const closeConfirmDialogBox = () => {
  setOpenConfirmDialogBox(false);
};


const handleSelect = () => {
 
  setExpanded(!expanded)
}

const handleonChange = (e) => {
  setChatName(e.target.value )
  
}

  return (
    <Navbar  expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
   
        {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }

        {
          
          (createtestmode || selecttestmode || createcollegetestmode) &&
                <div> 
                  <label className="navbarTitle"> {title}</label>
                  <label className="navbarTemplateName"> {chatName} </label>
                </div>
        }
        {
          (createtestmode || createcollegetestmode) &&
          <div style = {{marginRight: '10px'}}>
            <PushButton disabled = {isLoading} onClick={handleonClickNavBar} label =  {changeLanguage('aitest','savedtests')}/>
          </div>  
        }
     
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
        >
          <Offcanvas.Header onClick={handleSelect}  >
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack size='lg' className="styleIconWithBackground" onClick = {handleonArrowClick} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
            <label className="navbarTemplatesTitle">{changeLanguage('aitest','tests')}</label>

      
            <div className="displayTestsContainer">
              
                <ul className="navbarNames">
                    {
                        Array.isArray(chatNames) &&
                       
                            chatNames.map((chat) => (
                              <React.Fragment key={chat.id}>
                                <DisplayMyCreatedTests chat={chat} deleteHandler={handleDeleteTest} clickHandler={displayChat} setExpand = {handleSelect} setTemplateName = {setChatName}/>
                                <hr className = 'aitestLineSeparator'></hr>
                              </React.Fragment>
                            ))
                    }
                </ul>
            </div>
                 
       
        <br></br>

            <SaveChat label="Test name" text={chatName} disabled={promptsandresponses===null || promptsandresponses.length === 0} onChange={handleonChange} onSave={onSave}/>
           
            {
                (statusNavbar) &&
                    <div className='statusLabel'><label>{statusNavbar}</label></div>
              }
          <br></br>

        {/*
          <label style={{paddingRight:'5px', color:'maroon', fontSize:'18px', fontWeight:'500'}}> {changeLanguage('aitest', 'freevspaidtest')} </label>
          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text42')} 
          </p>
        */}
          <label style={{paddingRight:'5px', color:'maroon', fontSize:'18px', fontWeight:'500'}}> {changeLanguage('aitest', 'howtocreatetest')} </label>
          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text4')} 
          </p>


          <div className = 'flex-container' style={{marginTop: '-10px'}}>
              
                <Checkbox className='checkBoxTestName'
                  checked={true}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'}, 
                      
                  }} />
             
            <label style={{paddingRight:'5px'}}> {changeLanguage('aitest', 'activated')} </label>

          </div>

          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text3')} 
                  <br></br>
            </p>

          <div>
           
           
            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text22')} 
            </p>

            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text41')} 
            </p>

          {/*
            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text43')} 
            </p>
          */}
         
          
          </div>
        
            <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogboxtext}/>
            <AlertDialog alertYes={alertSaveTestYes} alertCancel={alertSaveTestCancel} openDialog = {openSaveTestDialog} closeDialog = {closeSaveTestDialogBox} prompt={dialogboxtext}/>
            <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogboxtext}/>
          </Nav>
           
          </Offcanvas.Body>
        </Navbar.Offcanvas>
  
    </Navbar>
  );
}

export default NavBarTest;